export enum SCHEDULE_STATUS {
  ACTIVE = 'ACTIVE',
  IN_PROGRESS = 'IN_PROGRESS',
  COMPLETED = 'COMPLETED',
  RE_OPEN = 'RE_OPEN',
  USER_CANCELLED = 'USER_CANCELLED',
}
